/** @jsxImportSource @emotion/react */

import { FC, ReactNode } from "react";
import Column from "../../../../Grid/Column";
import { useUIStore } from "../../../../../hooks/useUIStore";
import { getThemeColorFromAlias, theme } from "../../../../../theme";
import { css } from "@emotion/react";
import TableRow from "./TableRow";

interface TableColumnProps {
  column: {
    label: string;
    value: string | ReactNode;
  }[];
  mobile?: boolean;
  hideLabels?: boolean;
  hideValues?: boolean;
  columnsQuantity: number;
}

export const TableColumn: FC<TableColumnProps> = ({
  column,
  mobile,
  hideLabels,
  hideValues,
  columnsQuantity,
}) => {
  const { documentColor } = useUIStore();
  const color = getThemeColorFromAlias(documentColor, theme.colors);

  const styles = {
    borderLeft: {
      "&:not(:first-of-type)": {
        backgroundImage: `linear-gradient(to bottom, ${color} 50%, transparent 0%)`,
        backgroundSize: "1.5px 15px",
        backgroundRepeat: "repeat-y",
        minWidth: 180,
      },
    },
    row: {
      marginTop: 8,
    },
    column: {
      marginBottom: 16,
    },
  };

  return (
    <Column
      xs={12}
      sm={12 / (columnsQuantity + 1)}
      css={css(!mobile && styles.borderLeft, styles.column)}
    >
      {column.map((row, index) => (
        <TableRow
          key={`table-row-${index}`}
          row={row}
          tableHead={!mobile && index === 0}
          hideLabels={(!mobile && hideLabels) || (mobile && index === 0)}
          hideValues={!mobile && hideValues}
        />
      ))}
    </Column>
  );
};

export default TableColumn;
